import { render, staticRenderFns } from "./Lessonplan.vue?vue&type=template&id=6b10a6f6&scoped=true&"
import script from "./Lessonplan.vue?vue&type=script&lang=js&"
export * from "./Lessonplan.vue?vue&type=script&lang=js&"
import style0 from "./Lessonplan.vue?vue&type=style&index=0&id=6b10a6f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b10a6f6",
  null
  
)

export default component.exports